<template>
  <div class="supervisor-worker-list-view" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="施工工人" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="supervisor-worker-item" v-for="worker in supervisorWorkerList" @click="toDetail(worker.id)">
      <img :src="imgUrl + worker.avatar">
      <div class="service-user-info">
        <div class="top">
          <div class="name">{{worker.name}}</div>
          <div class="worker-age">工龄&nbsp;&nbsp;<span class="value">{{worker.workAge}}</span></div>
        </div>
        <div class="footer" v-if="worker.workTypeList.length>0">
          <div v-for="workType in worker.workTypeList" class="work-type">
            {{workType}}
          </div>
        </div>
      </div>
    </div>
    <div v-if="supervisorWorkerList.length==0" class="black-page">
      <img src="../../assets/icon-no-img.png">
      <div class="tip">暂无相关施工工人!</div>
    </div>
  </div>
</template>
<script>
  import {imgUrl,shareIcon} from '../../config'
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import supervisorWorkerService from '../../service/onestop/OnestopSupervisorWorkerService'

  export default {
    name: 'SupervisorWorkerList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        supervisorWorkerList:[],
        imgUrl: imgUrl,
        isWechatBrowser:this.$verfyBrowserType(),
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getSupervisorWorkerList();
    },
    methods: {
      toDetail(id){
        this.$router.push({name:'WorkerDetail',query:{id}});
      },
      async getSupervisorWorkerList(){
        let { code, data} = await supervisorWorkerService.list();
        if(code == 0){
          this.supervisorWorkerList = data;
          for (let worker of this.supervisorWorkerList){
            if(worker.workTypeDesc){
              this.$set(worker,'workTypeList',worker.workTypeDesc.split(','));
            }
          }
        }else {
          Toast('获取施工工人信息失败');
        }
      },
    }
  }
</script>

<style lang="scss">
  @import '../../assets/style/common.scss';
  .supervisor-worker-list-view{
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
    background: white;
    font-size: 0.24rem;
    color: #191818;
    .supervisor-worker-item{
      display: flex;
      width: 6.5rem;
      padding: 0.3rem 0.2rem;
      margin: 0 auto 0.2rem;
      border-radius: 0.08rem;
      box-shadow: 0rem 0.02rem 0.07rem 0rem
      rgba(0, 0, 0, 0.1);
      img{
        width: 1.3rem;
        height: 1.3rem;
        border-radius: 0.1rem;
      }
      .service-user-info{
        margin-left: 0.2rem;
        .top{
          display: flex;
          padding-bottom: 0.3rem;
          .name{
            font-size: 0.36rem;
            font-weight: bold;
          }
          .worker-age{
            margin-left: 0.3rem;
            margin-top: 0.12rem;
            color: #7f7d7c;
            .value{
              font-size: 0.26rem;
            }
          }
        }
        .footer{
          display: flex;
          .work-type{
            padding: 0.08rem 0.37rem;
            background: #e0dedc;
            border-radius: 0.3rem;
            margin-right: 0.2rem;
          }
        }
      }
    }
  }
</style>
